import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Form, Input, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import { responsive } from "../../utils/style";
import {
  onChangePassword,
  setIsSuccess,
  setError,
} from "../../stores/changePassword";
import { passwordRegexp } from "../../utils/password";
import PasswordSuggest from "../../components/PasswordSuggest";
import CompletedModal from "../../components/ChangePassword/Modal";
import { SubmitButton } from "../../components/CustomFields";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isSuccess, errorMessage } = useSelector(
    (state) => state.changePassword
  );
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(setIsSuccess(false));
    dispatch(setError(""));
  }, []);

  const onFinish = (values) => dispatch(onChangePassword(values));
  const onClose = () => {
    dispatch(setIsSuccess(false));
    navigate("/profile");
  };

  return (
    <Container>
      <Background>
        <CompletedModal visible={isSuccess} onClose={onClose} />
        <Topic>เปลี่ยนรหัสผ่าน</Topic>
        <StyleForm
          form={form}
          name="changePassword"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            name="oldPassword"
            label="รหัสผ่านเดิม"
            required={false}
            validateStatus={errorMessage && "error"}
            help={errorMessage}
            rules={[{ required: true, message: "โปรดระบุ" }]}
          >
            <Input.Password placeholder="โปรดระบุ" />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="รหัสผ่านใหม่"
            required={false}
            rules={[
              { required: true, message: "โปรดระบุ" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value && value == getFieldValue("oldPassword")) {
                    return Promise.reject(
                      new Error("รหัสผ่านใหม่ต้องไม่ตรงกับรหัสผ่านเดิม")
                    );
                  } else if (!passwordRegexp.test(value) && value) {
                    return Promise.reject(
                      new Error("รูปแบบรหัสผ่านไม่ถูกต้อง")
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input.Password placeholder="โปรดระบุ" />
          </Form.Item>
          <Form.Item
            name="newPasswordConfirmation"
            label="ยืนยันรหัสผ่านใหม่"
            required={false}
            rules={[
              { required: true, message: "โปรดระบุ" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value !== getFieldValue("newPassword") && value) {
                    return Promise.reject(new Error("รหัสผ่านใหม่ไม่ตรงกัน"));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input.Password placeholder="โปรดระบุ" />
          </Form.Item>
          <PasswordSuggest />
          <Form.Item shouldUpdate>
            {() => (
              <SubmitWrapper>
                <SubmitButton
                  htmlType="submit"
                  disabled={
                    !form.isFieldsTouched(true) ||
                    !!form
                      .getFieldsError()
                      .filter(({ errors }) => errors.length).length
                  }
                >
                  เปลี่ยนรหัส
                </SubmitButton>
              </SubmitWrapper>
            )}
          </Form.Item>
        </StyleForm>
      </Background>
    </Container>
  );
};

export default ChangePassword;

const Container = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  background-color: #fffbeb;

  input {
    border-radius: 4px;
    height: 52px;
    font-size: 18px;
  }
  .ant-input-affix-wrapper {
    font-size: 18px;
  }
`;
const Background = styled.div`
  width: 1144px;
  background-color: white;
  margin: auto;
  height: 100vh;

  ${responsive.tablet(css`
    width: 100%;
  `)}
`;
const Topic = styled.h5`
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #058459;

  ${responsive.mobile(css`
    font-size: 18px;
  `)}
`;
const SubmitWrapper = styled.div`
  text-align: center;
  margin-top: 24px;
`;
const StyleForm = styled(Form)`
  margin: auto;
  margin-top: 40px;
  max-width: 440px;
`;
